import produce from 'immer';
import create from 'zustand';

const useNavigationStore = create(set => ({
  items: [],
  set: fn => set(produce(fn)),
}));

export default useNavigationStore;
